/**
 * this file holds all redux constants
 * to avoid spelling mistakes when calling reducers & actions
 *
 * Created by Tom on 23/05/18
 */

const constants = {

    // componentReducer
    SET_OPEN_LEFT_MENU: 'SET_OPEN_LEFT_MENU',
    SET_OPEN_RIGHT_MENU: 'SET_OPEN_RIGHT_MENU',
    SET_OPEN_CONGRATS_INFO: 'SET_OPEN_CONGRATS_INFO',

    // portfolioReducers
    SET_PORTFOLIO_LOADER: 'SET_PORTFOLIO_LOADER',
    FETCH_PORTFOLIO_DATA: 'FETCH_PORTFOLIO_DATA',
    SET_PORTFOLIO_DATA: 'SET_PORTFOLIO_DATA',

    // investmentReducers
    SET_INVESTMENT_LOADER: 'SET_INVESTMENT_LOADER',
    FETCH_INVESTMENT_DATA: 'FETCH_INVESTMENT_DATA',
    SET_INVESTMENT_DATA: 'SET_INVESTMENT_DATA',

    // transactionReducers
    SET_TRANSACTION_LOADER: 'SET_TRANSACTION_LOADER',
    SET_TRANSACTION_START_DATE: 'SET_TRANSACTION_START_DATE',
    SET_TRANSACTION_END_DATE: 'SET_TRANSACTION_END_DATE',
    FETCH_TRANSACTION_DATA: 'FETCH_TRANSACTION_DATA',
    SET_TRANSACTION_FETCH_SUCCESS: 'SET_TRANSACTION_FETCH_SUCCESS',
    SET_TRANSACTION_DATA: 'SET_TRANSACTION_DATA',
    SET_TRANSACTION_CLOSING_BALANCE: 'SET_TRANSACTION_CLOSING_BALANCE',
    CLEAR_DATE_RANGE: 'CLEAR_DATE_RANGE',

    // newsReducers
    SET_NEWS_LOADER: 'SET_NEWS_LOADER',
    FETCH_NEWS_DATA: 'FETCH_NEWS_DATA',
    SET_NEWS_DATA: 'SET_NEWS_DATA',

    // userReducer
    SET_USER: 'SET_USER',
    SET_USER_PREFERENCES: 'SET_USER_PREFERENCES'
}

export default constants



// WEBPACK FOOTER //
// ./src/constants.js